import { Base64 } from 'js-base64'

class PluginCrypto {
  // 加密
  encode({ id, name, author, url, code }) {
    const base64Encode = Base64.encode
    const utf8Encode = this.old_utf8_encode || this.utf8_encode
    const json = JSON.stringify({ id, name, author, url, code })
    return base64Encode(utf8Encode(json))
  }

  // 解密
  decode(base64Str) {
    const base64Decode = Base64.decode
    const utf8Decode = this.old_utf8_decode || this.utf8_decode
    const json = utf8Decode(base64Decode(base64Str))
    return JSON.parse(json)
  }

  // unicode编码
  utf8_encode(string) {
    string = string.replace(/\r\n/g, '\n')
    let utftext = ''
    for (let n = 0; n < string.length; n++) {
      const c = string.charCodeAt(n)
      if (c < 128) {
        utftext += String.fromCharCode(c)
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192)
        utftext += String.fromCharCode((c & 63) | 128)
      } else {
        utftext += String.fromCharCode((c >> 12) | 224)
        utftext += String.fromCharCode(((c >> 6) & 63) | 128)
        utftext += String.fromCharCode((c & 63) | 128)
      }
    }
    return utftext
  }

  // unicoe解码
  utf8_decode(utftext) {
    let string = ''
    let i = 0
    let c = 0
    let c2 = 0
    let c3 = 0
    while (i < utftext.length) {
      c = utftext.charCodeAt(i)
      if (c < 128) {
        string += String.fromCharCode(c)
        i++
      } else if ((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i + 1)
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63))
        i += 2
      } else {
        c2 = utftext.charCodeAt(i + 1)
        c3 = utftext.charCodeAt(i + 2)
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63))
        i += 3
      }
    }
    return string
  }

  // 旧版utf8编码
  old_utf8_encode(_string) {
    return _string.replace(/([\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF])/g, str => {
      return '\\u' + str.charCodeAt(0).toString(16)
    })
  }

  // 旧版utf8解码
  old_utf8_decode(unicodetext) {
    return unicodetext.replace(/(\\u[a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9])/ig, str => {
      return window.unescape(str.replace(/\\u/g, '%u'))
    })
  }
}

export default PluginCrypto

